<div class="container" [class.blurred-content]="estaEnviando">
    <div class="row group-head">
        <div class="col-12 d-inline-flex">
            <h1 *ngIf="!clientesCarregando">
                Cadastrar shape
            </h1>
        </div>
    </div>

    <div *ngIf="estaCarregando" class="loading">
        <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="clientesCarregando" class="loading">
        <mat-spinner></mat-spinner>
    </div>

    <form *ngIf="!estaCarregando && !clientesCarregando"[formGroup]="fazendaForm" class="group-form">
        <div class="row">
            <div class="col-6">
                <div class="row m-0">
                   <app-select-busca-cliente
                        [clientes]="clientesFormatados"
                        [matlabelOpcional]="'Selecione o cliente:'"
                        [valorSelecionado]="fazendaForm.get('fk_cliente')?.value"
                        [desabilitado]="false"
                        (clienteSelecionado)="onClienteSelecionadoCadastro($event)">
                    </app-select-busca-cliente>

                    <small class="message-validate-form"
                        *ngIf="fazendaForm.get('fk_cliente')?.invalid && fazendaForm.get('fk_cliente')?.dirty">
                        {{ mensagemErroCampo('fk_cliente') }}
                    </small>
                </div>
                <div class="row">
                    <div class="col-12 field-form">
                        <div class="row">
                            <div class="col-12 field-form">
                                <label>Adicionar GeoJSON</label>
                                <div class="drag-drop-area" (dragover)="aoArrastar($event, true)"
                                    (dragleave)="aoArrastar($event, false)" (drop)="aoSoltar($event)"
                                    (click)="fileInput.click()">
                                     <img src="../assets/icon-add-img.svg" class="img" alt="">
                                     Arraste e solte o arquivo GeoJSON aqui ou clique para selecionar
                                    <input type="file" #fileInput (change)="aoAlterarArquivo($event)" class="input-form"
                                        accept=".geojson,application/geo+json,.json" hidden>
                                </div>
                                <small class="message-validate-form"
                                    *ngIf="fazendaForm.get('arquivo')?.invalid && fazendaForm.get('arquivo')?.dirty">{{mensagemErroCampo('arquivo')}}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           <div class="col-6">
            <div class="row">
                <div class="col-12 field-form">
                    <label>Localização no mapa</label>
                    <app-mini-mapa-geojson 
                        [geojsonData]="geojsonData"
                        [clienteLatitude]="clienteSelecionado?.latitude"
                        [clienteLongitude]="clienteSelecionado?.longitude">
                    </app-mini-mapa-geojson>
                </div>
            </div>
           </div>
           <div id="buttons">
                <button class="btn-sucesso btn btn-lg btn-success" (click)="submit()"
                    [disabled]="!fazendaForm.valid">Cadastrar</button>
                <button routerLink="../" class="btn-cancelar btn btn-lg btn-danger" type="btn">Cancelar</button>
           </div>
        </div>
    </form>

    <div *ngIf="estaEnviando && !estaCarregando" class="overlay">
        <div class="blurred-overlay-background"></div>
        <div class="overlay-content">
            <mat-spinner></mat-spinner>
            <p>{{ mensagemEnvio }}</p>
        </div>
    </div>
</div>